import { render, staticRenderFns } from "./viewtitle.vue?vue&type=template&id=73b4324a&scoped=true&"
import script from "./viewtitle.vue?vue&type=script&lang=js&"
export * from "./viewtitle.vue?vue&type=script&lang=js&"
import style0 from "./viewtitle.vue?vue&type=style&index=0&id=73b4324a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b4324a",
  null
  
)

export default component.exports